import $ from 'jquery';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from './router';
import App from './App.vue';

const el = '#thelist';
const $rootEl = $(el);
const gaId = $rootEl.data('ga-id');

if (gaId) {
    Vue.use(VueAnalytics, {
        id: gaId,
        router
    });
}


new Vue({ // eslint-disable-line no-new
    router,
    el,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./assets/js/thelist/index.js